import React from 'react'
import './About.css'

const About = (props) => {

  document.title = "About Us - Out of Last Place Mississippi"

  return (
    <div>
      <section className="pages-hero about-hero">
        <h4>About OLPI</h4>
      </section>

      <section id="about-section" className="content-section about-section">

          <div className="about-content">

            <div className="vision-mission">
              <h5>Who We Are</h5>

              <p>The “Out of Last Place Institute” is a partnership of business leaders dedicated to getting Mississippi permanently and forever “out of last place” as defined by our state’s per-capita income, which we believe is the best economic measure of human prosperity and well-being.</p>
            </div>

            <hr />

            <div className="vision-mission">
              <h5>Our Vision</h5>

              <p>Our vision is for Mississippi to be a place where “last place” is permanently our “past place,” so that no other state can legitimately still say “Thank God for Mississippi” (<a href="https://en.wikipedia.org/wiki/Thank_God_for_Mississippi" target="_blank" >Wikipedia</a>).</p>
            </div>

            <hr />

            <div className="vision-mission">
              <h5>Our Mission</h5>

              <p>To publish comprehensive research and solutions to definitively determine:</p>

                  <ul>
                    <li>When and how Mississippi got in last place</li>
                    <li>Why Mississippi is still in last place.</li>
                    <li>What specific, concrete, and actionable steps would be required to get Mississippi out of last place.</li>
                  </ul>
            </div>

            <hr />

            <div className="contact">
              <h5><a href="mailto:info@outoflastplace.com?subject=Contact%20-%20OLPI%20Website">Contact Us</a></h5>
            </div>

          </div>

      </section>
    </div>
  )
}

export default About;



/** WEBPACK FOOTER **
 ** ./src/components/pages/About.js
 **/